import React, { useState } from 'react';
import styles from './Join.module.css';

const JoinForm: React.FC = () => {
  const [formData, setFormData] = useState({
    userId: '',
    password: '',
    passwordConfirm: '',
    name: '',
    email: '',
    phone: '',
    birth: '',
    gender: '',
    agreeTerms: false,
    agreePrivacy: false,
    agreeMarketing: false
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('회원가입 데이터:', formData);
  };

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <h2 className={styles.title}>회원가입</h2>

        <div className={styles.inputGroup}>
          <label className={styles.label}>아이디 <span>*</span></label>
          <input type="text" name="userId" value={formData.userId} onChange={handleInputChange} className={styles.input} required />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>비밀번호 <span>*</span></label>
          <input type="password" name="password" value={formData.password} onChange={handleInputChange} className={styles.input} required />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>비밀번호 확인 <span>*</span></label>
          <input type="password" name="passwordConfirm" value={formData.passwordConfirm} onChange={handleInputChange} className={styles.input} required />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>이름 <span>*</span></label>
          <input type="text" name="name" value={formData.name} onChange={handleInputChange} className={styles.input} required />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>이메일</label>
          <input type="email" name="email" value={formData.email} onChange={handleInputChange} className={styles.input} />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>휴대폰 번호 <span>*</span></label>
          <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} className={styles.input} required />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>생년월일</label>
          <input type="date" name="birth" value={formData.birth} onChange={handleInputChange} className={styles.input} />
        </div>

        <div className={styles.terms}>
          <label>
            <input type="checkbox" name="agreeTerms" checked={formData.agreeTerms} onChange={handleInputChange} required />
            이용약관 동의 (필수)
          </label>
          <label>
            <input type="checkbox" name="agreePrivacy" checked={formData.agreePrivacy} onChange={handleInputChange} required />
            개인정보 수집 및 이용 동의 (필수)
          </label>
          <label>
            <input type="checkbox" name="agreeMarketing" checked={formData.agreeMarketing} onChange={handleInputChange} />
            마케팅 수신 동의 (선택)
          </label>
        </div>

        <button type="submit" className={styles.submitButton}>회원가입</button>
      </form>
    </div>
  );
};

export default JoinForm;
